// Height values for each size (in pixels)
export const BUTTON_HEIGHTS = {
  sm: 32,
  md: 36,
  lg: 42,
  xl: 48,
} as const;

// Padding multipliers for each size (in theme spacing units - 4px)
export const BUTTON_PADDING_MAP = {
  sm: 4,
  md: 5,
  lg: 6,
  xl: 7,
} as const;
